'use strict';

import moment from 'moment';

import template from 'commons/templates/Main.ejs';
import NavMenuTpl from '../templates/NavMenu.ejs';
import HeaderMenuTpl from '../templates/HeaderMenu.ejs';
import Alerts from 'lib/alerts';
import FreeAccountSetup from 'commons/views/FreeAccountSetup';
import tooltip from 'helpers/tooltip';
import modal from 'helpers/modal';
import {consts as EmployeeConsts} from 'newModels/employee.js';
import Payroll from 'newModels/payroll.js';
import Employees from 'newCollections/employees.js';

module.exports = Backbone.View.extend({
    el:      '.content',
    childEl: '#main-area',

    events: {
        'click .js-free-account-setup': 'freeAccountSetup',
        'click .snooze-button': 'hideAlert',
        'click .alert-link': 'exitLink'
    },

    initialize: function() {
        this.model.on('sync change', this.renderCompanyName, this);
        this.model.on('sync change', this.renderContactName, this);
        this.model.on('change:logoUrl', this.renderLogo, this);
        return this.render();
    },

    render: function() {
        const id = app.company.get('mppAdminId');
        const logoUrl = app.user.getLogoUrl(id);
        let altRole = '';
        if (app.user.get('role').match(/(admin|mpp)/)) {
            altRole = app.user.get('role');
        }

        this.$el.html(template({
            navMenu: NavMenuTpl({
                model:   this.model,
                altRole: altRole
            }),
            headerMenu: HeaderMenuTpl({
            }),
            version: app.version,
            whitelabel: (
                app.company.get('mppAdminId') ||
                (app.subscription && app.subscription.get('plan') !== 'client')
            ),
            logoUrl: logoUrl
        }));

        // update EIS/SOCSO once a month
        const prevLoginPayrollPeriodDate = Payroll.getPeriodFromDate(
            this.lastActive()
        );
        if (
            moment(Payroll.getCurrentPeriodDate())
                .isAfter(prevLoginPayrollPeriodDate, 'month')
        ) {
            const employees = new Employees(null, {
                company: app.company,
                pagination: false
            });
            employees.fetch({
                filter: {
                    where: {
                        hiddenAt: null
                    },
                    limit: 9999
                }
            })
            .then(() => this.updateSatutoryFor18(employees))
            .then(() => this.updateSatutoryFor60(employees));
        }

        $('body').removeClass('gray-bg');

        this.$('#side-menu').metisMenu({
            toggle:      false,
            activeClass: 'active-group'
        });

        this.$el.find('.logo img')
            .on('load', (e) => {
                $(e.target.parentElement).removeClass('hidden');
            })
            .on('error', (e) => {
                e.target.src = '';
            });

        tooltip.initBody();

        this.trigger('render');

        return this;
    },

    lastActive: function() {
        return moment(app.company.get('lastActiveTime'));
    },

    renderCompanyName: function() {
        this.$('.js-company-name').text(this.model.get('companyName'));
    },

    renderContactName: function() {
        this.$('.js-contact-name').text(this.model.get('contactName'));
    },

    renderLogo: function() {
        const hasLogo = !!this.model.get('logoUrl');
        const url = this.model.getLogoUrl();
        const $img = this.$('.js-nav-company-logo');

        if (hasLogo) {
            $img.removeClass('hidden').attr('src', url);
        } else {
            $img.addClass('hidden').attr('src', '');
        }
    },

    freeAccountSetup: function() {
        return FreeAccountSetup
            .freeAccountSetupRequest()
            .then(() => this.$('.js-free-account-setup').hide())
            .catch(() => {});
    },

    setActiveLink: function(route) {
        // for all 3 payroll steps
        if (route.indexOf('payroll/step') === 0) {
            route = 'payroll';
        }

        if (route.indexOf('settings') === 0) {
            route = 'settings';
        }

        var $parent = this.$el.find('#side-menu a[href="#' + route + '"]')
            .parent();
        var $sub = $parent.parent();

        this.$('#side-menu li').removeClass('active');

        $parent.addClass('active');

        if ($parent.parent().hasClass('nav-second-level')) {
            // show second level menu
            $sub.collapse('show');
            $sub.parent().addClass('active-group');
        }
    },

    hideAlert: function(ev) {
        this.$(ev.target).closest('.display-alert').addClass('hidden');
    },

    exitLink: function(ev) {
        ev.preventDefault();
        const isMppManager = app.user.get('role') === 'mpp_manager';
        if (isMppManager) {
            modal.warning({
                text: `Currently, there are outstanding invoices to be paid.\
                    <br>Please refer to MPP Admin for payment information.`,
                html: true
            });
        } else {
            window.location.href = ev.target.href;
        }
    },

    getEmployeeNameString: function(employees) {
        const getEmpName = employee => employee.get('fullName');
        if (employees.length > 1) {
            const empNames = employees.map(getEmpName);
            return `employees ${empNames.slice(0, -1).join(', ')}` +
                `, and ${empNames.slice(-1)} have`;
        }
        return `employee ${getEmpName(employees[0])} has`;
    },

    updateSatutoryFor18: function(employees) {
        // compare age last active and age now. if same, don't change anything
        const employeesToUpdate = employees.filter(employee => {
            const ageThisPayroll = employee.getAgeAtEndOfPeriod();
            const payrollMonth = new Payroll().getPeriod().month();
            const birthMonth = moment(employee.get('dob')).month();
            return ageThisPayroll === 18 && payrollMonth === birthMonth &&
                !employee.get('isEis') && employee.canContributeToEis();
        });

        if (employeesToUpdate.length > 0) {
            return Promise.all(employeesToUpdate.map(employee => {
                employee.set('isEis', true);
                return employee.save();
            }))
            .then(() => new Promise(resolve => Alerts.show('info', {
                title: `Update of Employees' Statutory Requirements`,
                text: `Your ${this.getEmployeeNameString(employeesToUpdate)} ` +
                    `reached the age of 18. Therefore, the EIS contribution ` +
                    `has been automatically enabled since they are now ` +
                    `eligible to contribute to the Employment Insurance ` +
                    `Scheme. If you wish to disable EIS, please proceed to ` +
                    `the Statutory Requirements tab in the employee’s ` +
                    `profile. <br />`,
                callback: () => resolve()
            })));
        }
    },

    updateSatutoryFor60: function(employees) {
        // compare age last active and age now. if same, don't change anything
        const employeesToUpdate = employees.filter(employee => {
            const ageThisPayroll = employee.getAgeAtEndOfPeriod();
            const payrollMonth = new Payroll().getPeriod().month();
            const birthMonth = moment(employee.get('dob')).month();
            return ageThisPayroll === 60 && payrollMonth === birthMonth &&
                (
                    ![
                        EmployeeConsts.SOCSO_CATEGORY_NONE,
                        EmployeeConsts.SOCSO_CATEGORY_INJURY
                    ].includes(employee.get('socsoCategory')) ||
                    employee.get('isEis')
                );
        });

        if (employeesToUpdate.length > 0) {
            return Promise.all(employeesToUpdate.map(employee => {
                employee.set(
                    'socsoCategory',
                    EmployeeConsts.SOCSO_CATEGORY_INJURY
                );
                employee.set('isEis', false);
                return employee.save();
            }))
            .then(() => new Promise(resolve => Alerts.show('info', {
                title: `Update of Employees' Statutory Requirements`,
                text: `Your ${this.getEmployeeNameString(employeesToUpdate)}` +
                    ` reached the age of 60. Therefore, the SOCSO ` +
                    `contribution category has automatically been changed ` +
                    `to ‘Employment Injury Scheme’ and EIS has been ` +
                    `disabled. If you wish to change the SOCSO category or ` +
                    `enable the EIS contribution,  please proceed to the ` +
                    `Statutory Requirements tab in the employee’s profile. ` +
                    `<br />` +
                    // jscs:disable
                    `For more information, please ` +
                    // jscs:disable
                    `read <a target="_blank" href="https://help.payrollpa` +
                    `nda.my/perkeso/what-are-` +
                    `the-differences-between-the-two-socso-categories">` +
                    `What are the differences between the two SOCSO categori` +
                    `es?</a> and <a target="_blank" href="https://help.payro` +
                    `llpanda.my/perkeso/294777-what-is-the-employment-insuran`+
                    `ce-system-eis">What is the Employment Insurance System ` +
                    `(EIS)?</a>`,
                    callback: () => resolve()
            })));
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/Main.js